// CSS-only marquees: children are real text in the HTML (SSR-friendly),
// animation is a pure CSS translateX loop — no measurement, no JS gating.
const MarqueeTrack = ({ items, renderItem, duration, pauseOnHover = false }) => {
  // Repeat short lists so one half of the track always exceeds the viewport
  const seq = Array.from({ length: Math.max(1, Math.ceil(14 / items.length)) }, () => items).flat();
  return (
    <div className={`overflow-hidden${pauseOnHover ? " marquee-pausable" : ""}`}>
      <div className="marquee-track" style={{ "--marquee-duration": `${duration}s` }}>
        <div className="marquee-half">{seq.map(renderItem)}</div>
        <div className="marquee-half" aria-hidden="true">{seq.map(renderItem)}</div>
      </div>
    </div>
  );
};

export const RedRibbon = ({ items }) => (
  <div className="border-y border-nexa-black bg-nexa-red py-4 text-nexa-black" data-testid="services-marquee">
    <MarqueeTrack
      items={items}
      duration={22}
      pauseOnHover
      renderItem={(item, i) => (
        <span key={i} className="mx-6 flex items-center gap-6 font-display text-2xl uppercase tracking-tight md:text-3xl">
          {item}
          <span className="text-nexa-bone">/</span>
        </span>
      )}
    />
  </div>
);

export const LedgerMarquee = ({ names }) => (
  <div className="border-y border-white/10 py-6" data-testid="client-ledger-marquee">
    <MarqueeTrack
      items={names}
      duration={80}
      renderItem={(n, i) => (
        <span key={i} className="mx-8 font-mono text-sm uppercase tracking-[0.25em] text-nexa-bone/40">
          {n} <span className="ml-8 text-nexa-red">·</span>
        </span>
      )}
    />
  </div>
);
